let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lHgWo")).then(() => parcelRequire('527kD'));